import React, { forwardRef, useEffect, useState } from 'react';
// material
import CloseIcon from '@material-ui/icons/Close';
import {
  Slide,
  Dialog,
  AppBar,
  Toolbar,
  Typography,
} from '@material-ui/core';
//
import ViewOfficialRequest from 'src/pages/dashboard/ViewProposals.js';

const Transition = forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);
 function FullScreenDialogPurchaseOrder({
  open,
   setOpen,
   projectId:initialProjectId,
   projectName:initialProjectName,
   isEditPurchaseOrder:initialIsEditPurchaseOrder,
   setRenderCards,
   renderCards
  }) {

  const [dataChanged, setDataChanged] = useState(false); 
// const[jobCostId,setJobCostId]=useState('');
const [projectId, setProjectId] = useState(
  localStorage.getItem('purchaseOrderProjectId') || initialProjectId || ''
);
console.log("purchaseOrderProjectId",projectId);

const [projectName, setProjectName] = useState(
  localStorage.getItem('purchaseOrderProjectName') || initialProjectName || ''
);
const [isEditPurchaseOrder, setIsEditPurchaseOrder] = useState(
  localStorage.getItem('isEditPurchaseOrder') === 'true' || initialIsEditPurchaseOrder || false
);
useEffect(() => {
  if (open) {
    localStorage.setItem('purchaseOrderProjectId', projectId);
    localStorage.setItem('purchaseOrderProjectName', projectName);
    localStorage.setItem('isEditPurchaseOrder', isEditPurchaseOrder);
    localStorage.setItem('purchaseOrderOpenProductionPopup', 'true');
  } else {
    // localStorage.removeItem('purchaseOrderProjectId');
    // localStorage.removeItem('purchaseOrderProjectName');
    // localStorage.removeItem('isEditPurchaseOrder');
    localStorage.removeItem('purchaseOrderOpenProductionPopup',);
  }
}, [open, projectId, projectName, isEditPurchaseOrder]);
useEffect(() => {
  if (open) {
    setProjectId(localStorage.getItem('purchaseOrderProjectId') || initialProjectId || '');
    setProjectName(localStorage.getItem('purchaseOrderProjectName') || initialProjectName || '');
    setIsEditPurchaseOrder(localStorage.getItem('isEditPurchaseOrder') === 'true' || initialIsEditPurchaseOrder || false);
  }
}, [open]);
  const handleClose = () => {
    console.log('purchaseOrderProjectId======')
    setProjectId("");
    setProjectName("");
    setIsEditPurchaseOrder("");
    setOpen(false);
    localStorage.removeItem('purchaseOrderProjectId');
    localStorage.removeItem('purchaseOrderProjectName');
    localStorage.removeItem('isEditPurchaseOrder');
    localStorage.removeItem('purchaseOrderOpenProductionPopup',);
    if (dataChanged) {
      setRenderCards(!renderCards);
      setDataChanged(false); // Reset the flag after triggering the re-render
    }
  };
  const handleDataChange = (data) => {
    setDataChanged(true); 
    console.log('Entered=handleDataChange')
    if(data==="change"){
      console.log('Entered=handleDataChange=change')
      setRenderCards(!renderCards);
      setProjectId("");
      setProjectName("");
      setIsEditPurchaseOrder("");
      setOpen(false);
      localStorage.removeItem('purchaseOrderProjectId');
      localStorage.removeItem('purchaseOrderProjectName');
      localStorage.removeItem('isEditPurchaseOrder');
      localStorage.removeItem('purchaseOrderOpenProductionPopup');
      setDataChanged(false); 
    }
  };
  console.log("purchaseOrderProjectId1",projectId);
  return (
    <>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar position="relative" mb={3}>
          <Toolbar>
            <Typography variant="h6" sx={{ flex: 1, ml: 2 }}>
              {projectName}
            </Typography>
              <CloseIcon onClick={handleClose} sx={{fontSize:'2.7rem',cursor:'pointer'}}/>
          </Toolbar>
        </AppBar>
        <MemoizedViewPurchaseOrder
          popupOn={true}
          setRenderCards={setRenderCards}
          projectId={projectId}
          isEditPurchaseOrder={isEditPurchaseOrder}
          setIsEditPurchaseOrder  ={setIsEditPurchaseOrder}
          closeView={handleClose}
          renderCards={renderCards}
          handleDataChange={handleDataChange}
        />
      </Dialog>
    </>
  );
}
const MemoizedViewPurchaseOrder = React.memo(ViewOfficialRequest);

export default React.memo(FullScreenDialogPurchaseOrder);